import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getCategoryBySlug } from '../data/categoriesData';
import PromoBanner from '../components/PromoBanner/PromoBanner';
import './CategoryPage.css';

const CategoryPage = () => {
  const { categorySlug } = useParams();
  const category = getCategoryBySlug(categorySlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categorySlug]);

  return (
    <main className="category-page">
      <div className="category-container">
        
        {/* Centered Header Section matching reference image */}
        <div className="category-header-centered">
          <span className="category-breadcrumb">{category.breadcrumb}</span>
          <h1 className="category-main-title">{category.title}</h1>
          <p className="category-subtitle">{category.subtitle}</p>
        </div>

        {/* 2x2 Grid of Solid Black Horizontal Cards matching reference image */}
        <div className="category-products-grid">
          {category.models.map((model) => (
            <Link 
              to={`/product/${model.slug}`} 
              className="category-product-card" 
              key={model.id}
              onClick={() => window.scrollTo(0, 0)}
            >
              {/* Card Left Image */}
              <div className="category-card-img-wrapper">
                <img 
                  src={model.image} 
                  alt={model.name} 
                  className="category-card-img" 
                />
              </div>

              {/* Card Right Text Content & White Circular Arrow Badge */}
              <div className="category-card-content">
                <div className="category-card-text-block">
                  <h3 className="category-card-item-title">{model.name}</h3>
                  <p className="category-card-item-desc">{model.description}</p>
                </div>

                <div className="category-card-action-badge">
                  <svg 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>

      {/* Reusable Promo Banner Section (Same as HomePage) */}
      <PromoBanner />
    </main>
  );
};

export default CategoryPage;

